import { Component } from "@angular/core";

@Component({
  selector: "app-logo-badges",
  templateUrl: "logo-badges.component.html",
})
export class LogoBadgesComponent {}
